// Copyright (c) 2026 Goffy. This file belongs to Goffy. All Rights Reserved.

// The games that need whole fourballs: Best Ball, Worst Ball and Best ball–worst ball. Each is
// played as two pairs inside a ball, so a field that does not split into full fourballs leaves a
// pair with nobody to play. The rule is on the round's player count: these three are played only
// when it is a multiple of four. A round whose count does not fit still opens; the game is simply
// not played in it. Mirrors Goffy.Contracts FourballGames (C#), which every service applies —
// the GUIDs are the same well-known ids as WellKnownGameDefinitionIds.cs and config/golf-games.

export const BEST_BALL_GAME_ID = '8dbf1961-9d07-4e15-bf95-e81d55fe41a4';
export const WORST_BALL_GAME_ID = '1b06cb5e-6edc-4d95-9c27-f008d9db7b98';
export const BEST_BALL_WORST_BALL_GAME_ID = '9e183962-7a3d-4719-b7e3-f64f095b8b6e';

export const FOURBALL_GAME_IDS: ReadonlySet<string> = new Set([
  BEST_BALL_GAME_ID,
  WORST_BALL_GAME_ID,
  BEST_BALL_WORST_BALL_GAME_ID,
]);

/** A ball is at most four players; the games here need every ball to be exactly that. */
export const PLAYERS_PER_BALL = 4;

export function isFourballGameId(gameId?: string | null): boolean {
  if (typeof gameId !== 'string') return false;
  return FOURBALL_GAME_IDS.has(gameId.trim().toLowerCase());
}

export function fitsWholeFourballs(playerCount: number): boolean {
  return Number.isInteger(playerCount) && playerCount > 0 && playerCount % PLAYERS_PER_BALL === 0;
}

/** Any other game at any count; a fourball game only when the field is whole fourballs. */
export function isPlayableGameId(gameId: string, playerCount: number): boolean {
  return !isFourballGameId(gameId) || fitsWholeFourballs(playerCount);
}

/** The ids a picker must refuse at this field size: the three, or none when the field fits. */
export function fourballGameIdsBlockedAt(playerCount: number): ReadonlySet<string> {
  return fitsWholeFourballs(playerCount) ? new Set() : FOURBALL_GAME_IDS;
}
